module.exports = __webpack_public_path__ + "static/media/KMH_4905.efcf0ac4.jpg";